import html5 from '../image/tenologias/html5.png'
import css3 from '../image/tenologias/css3.png'
import react from '../image/tenologias/react.png'
import redux from '../image/tenologias/redux.png'
import nodejs from '../image/tenologias/nodejs.png'
import expressjs from '../image/tenologias/expressjs.png'
import sequelize from '../image/tenologias/sequelize.png'
import postgresql from '../image/tenologias/postgresql.png'
import linkedin from '../image/tenologias/in.png'
import github from '../image/tenologias/github.png'
export default{
    "html5":html5,
    "css3":css3,
    "react":react,
    "redux":redux,
    "nodejs":nodejs,
    "expressjs":expressjs,
    "sequelize":sequelize,
    "postgresql":postgresql,
    "linkedin":linkedin,
    "github": github
    
}